export default __webpack_public_path__ + "static/media/Slider_3500_Web.0a4b0334.png";